import React, { useState, SetStateAction, useEffect } from 'react';
import { Grid, Typography, Box, InputLabel } from '@material-ui/core';
import DateFnsUtils from '@date-io/date-fns';
import { ptBR } from 'date-fns/locale';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { useStyles } from './styles';
import { Envolvidos } from '../../@types/engineeringTypes';

interface IProps {
  involved: Envolvidos;
  setInvolved: React.Dispatch<SetStateAction<Envolvidos>>;
}

const InvovedFormGroup: React.FC<IProps> = ({ involved, setInvolved }) => {
  const [involvedState, setInvolvedState] = useState<Envolvidos>(involved);
  const classes = useStyles();

  const handlePeriodChange = (key: string, date: Date | null) => {
    if (date?.getDate()) {
      setInvolved((prev) => {
        return { ...prev, [key]: date.toISOString() };
      });
    }
  };

  useEffect(() => {
    setInvolvedState(involved);
  }, [involved]);

  return (
    <Box className={classes.sectionContainer}>
      <Typography variant="h6">Envolvidos</Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <InputLabel className={classes.label}>
            Intervalo de datas no período antes
          </InputLabel>
          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
            <KeyboardDatePicker
              clearable
              variant="inline"
              format="dd/MM/yyyy"
              placeholder="dd/mm/aaaa"
              className={classes.dateInput}
              value={involved['Data Um Antes']}
              onChange={(event) => handlePeriodChange('Data Um Antes', event)}
              inputVariant="outlined"
              inputProps={{ style: { padding: '0 0 0 15px', height: 40 } }}
              showTodayButton
              autoOk
              error={false}
              helperText=""
            />
          </MuiPickersUtilsProvider>
        </Grid>
        <Grid item xs={12} md={6}>
          <InputLabel className={classes.label}>
            Intervalo de datas no período depois
          </InputLabel>
          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
            <KeyboardDatePicker
              clearable
              variant="inline"
              format="dd/MM/yyyy"
              placeholder="dd/mm/aaaa"
              className={classes.dateInput}
              value={involved['Data Um Depois']}
              minDate={involved['Data Um Antes']}
              onChange={(event) => handlePeriodChange('Data Um Depois', event)}
              inputVariant="outlined"
              inputProps={{ style: { padding: '0 0 0 15px', height: 40 } }}
              showTodayButton
              autoOk
              error={false}
              helperText=""
            />
          </MuiPickersUtilsProvider>
        </Grid>
        <Grid item xs={12} md={6}>
          <InputLabel className={classes.label}>Data Dois Antes</InputLabel>
          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
            <KeyboardDatePicker
              clearable
              variant="inline"
              format="dd/MM/yyyy"
              placeholder="dd/mm/aaaa"
              className={classes.dateInput}
              value={involved['Data Dois Antes']}
              onChange={(event) => handlePeriodChange('Data Dois Antes', event)}
              inputVariant="outlined"
              inputProps={{ style: { padding: '0 0 0 15px', height: 40 } }}
              showTodayButton
              autoOk
              error={false}
              helperText=""
            />
          </MuiPickersUtilsProvider>
        </Grid>
        <Grid item xs={12} md={6}>
          <InputLabel className={classes.label}>Data Dois Depois</InputLabel>
          <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBR}>
            <KeyboardDatePicker
              clearable
              variant="inline"
              format="dd/MM/yyyy"
              placeholder="dd/mm/aaaa"
              className={classes.dateInput}
              value={involved['Data Dois Depois']}
              minDate={involved['Data Dois Antes']}
              onChange={(event) => handlePeriodChange('Data Dois Depois', event)}
              inputVariant="outlined"
              inputProps={{ style: { padding: '0 0 0 15px', height: 40 } }}
              showTodayButton
              autoOk
              error={false}
              helperText=""
            />
          </MuiPickersUtilsProvider>
        </Grid>
      </Grid>
    </Box>
  );
};

export default InvovedFormGroup;
